export const BASE64_IMAGE = "data:image/png;base64,";
